import { Component, Input, inject } from '@angular/core';

import { AppConfig, APPCONFIG } from '@core';

import { EmployeeRouteInfoView } from '../models/employee-route-info-view.model';
import {Visit} from "planner-shared";

@Component({
    selector: 'app-employee-route-info',
    templateUrl: './employee-route-info.component.html',
    styleUrls: ['./employee-route-info.component.scss'],
    standalone: false
})
export class EmployeeRouteInfoComponent {
    private readonly appConfig = inject<AppConfig>(APPCONFIG);

    @Input() public employee: EmployeeRouteInfoView;
    @Input() public includeMap: boolean;
    @Input() public routeSolution: Visit[];
}
